import React, { useEffect, useState } from 'react';
import { graphql } from 'gatsby';
import {
    KontentStringValue,
    KontentRadioMultiChoice,
    KontentRichText,
    CTAConfiguration,
    KontentMedia,
} from '../../../types/KontentProps';
import { getMediaData, getMultiChoice } from '../Global/DataUtils';
import RichText from '../Global/RichText';
//@ts-ignore
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
//@ts-ignore
import * as styles from './support-contact-panel.module.css';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTaxonomy } from '../Global/DataUtils/taxonomyQueries';
import Jotform from '../Jotform';
import Cookies from 'js-cookie';
import CloseButton from '../Global/CloseButton';
import Modal from 'react-modal';

const { GATSBY_API_URL } = process.env;

type ShowHide = 'show' | 'hide';

interface DataFields {
    fieldName: string;
    fieldValue: string;
    isHidden: string;
    fieldLabel: string;
    isRequired: string;
}

interface Props extends CTAConfiguration {
    call_us_phone_number: KontentStringValue;
    contact_email: KontentStringValue;
    contact_email_default_body: KontentStringValue;
    contact_email_subject: KontentStringValue;
    email_field: KontentStringValue;
    message_field: KontentStringValue;
    phone_field: KontentStringValue;
    headline: KontentStringValue;
    show_or_hide_contact_and_hours: KontentRadioMultiChoice<ShowHide>;
    show_or_hide_form: KontentRadioMultiChoice<ShowHide>;
    associated_typeform: KontentStringValue;
    support_hours: KontentRichText;
    anchor_name: KontentStringValue;
    photo_button_cta_label: KontentStringValue;
    submission_cta_label: KontentStringValue;
    first_name_field: KontentStringValue;
    last_name_field: KontentStringValue;
    issues_list: {
        value: [
            {
                elements: {
                    associated_taxonomy_code_name: {
                        value: string;
                    };
                };
            }
        ];
    };
    attachment_disclaimer_text: KontentRichText;
    form_submission_confirmation_headline: KontentStringValue;
    form_submission_confirmation_description: KontentRichText;
    confirmation_button_copy: KontentStringValue;
    form_error_message_headline: KontentStringValue;
    form_error_message_description: KontentRichText;
    form_error_message_button_copy: KontentStringValue;
    order_number_field: {
        value: KontentStringValue;
    };
    subject_field: {
        value: KontentStringValue;
    };
    product_line_list: {
        value: [
            {
                elements: {
                    associated_taxonomy_code_name: {
                        value: string;
                    };
                };
            }
        ];
    };
    contact_method: {
        value: [
            {
                elements: {
                    associated_taxonomy_code_name: {
                        value: string;
                    };
                };
            }
        ];
    };
    contact_time: {
        value: [
            {
                elements: {
                    associated_taxonomy_code_name: {
                        value: string;
                    };
                };
            }
        ];
    };
    loading_image: KontentMedia;
}

const SupportContactPanel: React.FC<Props> = ({
    anchor_name,
    contact_email,
    contact_email_default_body,
    contact_email_subject,
    email_field,
    message_field,
    last_name_field,
    first_name_field,
    phone_field,
    headline,
    show_or_hide_contact_and_hours,
    show_or_hide_form,
    support_hours,
    photo_button_cta_label,
    submission_cta_label,
    issues_list,
    contact_method,
    contact_time,
    call_us_phone_number,
    form_submission_confirmation_headline,
    form_submission_confirmation_description,
    confirmation_button_copy,
    form_error_message_headline,
    form_error_message_description,
    form_error_message_button_copy,
    attachment_disclaimer_text,
    order_number_field,
    subject_field,
    product_line_list,
    associated_typeform,
    loading_image,
}) => {
    const [ipDetails, setIpDetails] = React.useState(null);
    const [firstNameValue, setFirstNameValue] = useState('');
    const [lastNameValue, setLastNameValue] = useState('');
    const [emailValue, setEmailValue] = useState('');
    const [phoneValue, setPhoneValue] = useState('');
    const [messageValue, setMessageValue] = useState('');
    const [honeyPotValue, setHoneyPotValue] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [fileList, setFileList] = useState([]);
    const [totalFileSize, setTotalFileSize] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [finalFilesUrls, setFinalFilesUrls] = useState([]);
    const [key, setKey] = useState(0);
    const [subjectField, setSubjectField] = useState('');
    const breakpoints = useBreakpoint();
    const [formStatus, setFormStatus] = useState<
        'initial' | 'success' | 'error'
    >('initial');
    const [isIOS, setIsIOS] = useState(false);

    const checkIOS = () => {
        setIsIOS(
            typeof window !== 'undefined' &&
                /iPhone|iPad|iPod/.test(window.navigator.userAgent)
        );
    };

    useEffect(() => {
        checkIOS();
    }, []);

    const callUsPhoneNumber = call_us_phone_number?.value;
    const contactEmail = contact_email?.value;
    const formSubmitConfirmationheadline =
        form_submission_confirmation_headline?.value;
    const formErrorMessageHeadline = form_error_message_headline?.value;
    const body = contact_email_default_body?.value;
    const subject = contact_email_subject?.value;
    const firstNameLabel = first_name_field?.value;
    const lastNameLabel = last_name_field?.value;
    const messageFieldLabel = message_field?.value;
    const emailAddressLabel = email_field?.value;
    const phoneFieldLabel = phone_field?.value;
    const uploadPhotoLabel = photo_button_cta_label?.value;
    const subjectFieldLabel = subject_field?.value;
    const taxonomies = useTaxonomy();
    const jotForm = associated_typeform?.value;
    const productLineList = taxonomies.filter(
        (taxonomyNode) =>
            taxonomyNode.node?.system?.codename ===
            product_line_list?.value[0]?.elements?.associated_taxonomy_code_name
                ?.value
    )[0];
    const contactMethodList = taxonomies.filter(
        (taxonomyNode) =>
            taxonomyNode.node?.system?.codename ===
            contact_method?.value[0]?.elements?.associated_taxonomy_code_name
                ?.value
    )[0];
    const contactTimeList = taxonomies.filter(
        (taxonomyNode) =>
            taxonomyNode.node?.system?.codename ===
            contact_time?.value[0]?.elements?.associated_taxonomy_code_name
                ?.value
    )[0];

    const loadingGif = getMediaData(loading_image);
    const [
        selectContactMethodDropdownValue,
        setSelectContactMethodDropdownValue,
    ] = useState('');
    const [selectContactTimeDropdownValue, setSelectContactTimeDropdownValue] =
        useState('');
    const [selectDropdownValue, setSelectDropdownValue] = useState('');

    const showContactAndHours =
        getMultiChoice(show_or_hide_contact_and_hours) === 'show';
    const showForm = getMultiChoice(show_or_hide_form) === 'show';
    let doc = typeof document !== 'undefined' ? document : null;
    const cookie = doc
        ? doc.cookie.split('; ').reduce((prev: any, current: any) => {
              const [name, ...value] = current.split('=');
              prev[name] = value.join('=');
              return prev;
          }, {})
        : '';
    const windowLocationSearch =
        typeof window! == 'undefined' ? '' : window.location.search;
    const urlParams = new URLSearchParams(windowLocationSearch);
    const leadsourceParam = urlParams.get('leadsource');
    const leadsourceValue = leadsourceParam ? leadsourceParam : '';
    const clientIDParam = urlParams.get('gclid');
    const clientIDValue = clientIDParam ? clientIDParam : '';
    const utmSourceParam = urlParams.get('utm_source');
    const utmSourceValue = utmSourceParam ? utmSourceParam : '';
    const utmMediumParam = urlParams.get('utm_medium');
    const utmMediumValue = utmMediumParam ? utmMediumParam : '';
    const utmCampaignParam = urlParams.get('utm_campaign');
    const utmCampaignValue = utmCampaignParam ? utmCampaignParam : '';
    const marketingChannelValue = utmSourceParam
        ? utmSourceParam
        : '' + cookie['_uc_referrer'];
    const iReferrerValue = cookie['_uc_referrer'];
    const lReferrerValue = cookie['_uc_last_referrer'];
    const iLandPageValue = cookie['_uc_initial_landing_page'];
    const visitsValue = cookie['_uc_visits'];
    const ucontentValue = cookie['_uc_utm_content'];
    const originOfLeadValue = 'website'; // this is not necessary here
    const emailSubscriptionFormValue = '';
    const pageTitleValue = 'US get pricing ';
    const innerContentRef = React.useRef(null);
    const isFirstRender = React.useRef(true);

    let today: any = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();
    today = mm + '/' + dd + '/' + yyyy;
    const notify = (msg: string) =>
        toast.dark(msg, {
            position: 'bottom-center',
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });

    const removeFile = (idx: number) => {
        setFileList((prevList) =>
            prevList.filter((file, index) => index !== idx)
        );
    };

    const onFileChange = (event: any) => {
        setKey((prevKey) => prevKey + 1);
        setErrorMsg('');
        let isValid = true;
        const files = event.target.files;
        const selectedFiles: File[] = Array.from(files);
        let totalSize = totalFileSize;

        if (selectedFiles.length > 5) {
            setErrorMsg(
                'Maximum 5 files allowed. Please select 5 or less files to attach.'
            );
            isValid = false;
            return;
        } else if (fileList.length + selectedFiles.length > 5) {
            setErrorMsg(
                'Maximum 5 files allowed. Please select 5 or less files to attach.'
            );
            isValid = false;
            return;
        } else {
            selectedFiles.forEach((file, index) => {
                const fileType = file.type;
                const isDuplicate = fileList.some(
                    (existingFile) => existingFile.name === file.name
                );
                if (file.size > 30e6) {
                    setErrorMsg(
                        'Total file size exceeds 30 MB. Please select files that add up to less than 30 MB.'
                    );
                    isValid = false;
                    return;
                }
                totalSize += file.size;
                if (totalSize > 30e6) {
                    setErrorMsg(
                        'Total file size exceeds 30 MB. Please select files that add up to less than 30 MB.'
                    );
                    isValid = false;
                    return;
                }
                if (isDuplicate) {
                    setErrorMsg(
                        "One or more files you've selected is already attached."
                    );
                    isValid = false;
                    return;
                }
                if (fileType.startsWith('video/')) {
                    if (
                        ![
                            'video/hevc',
                            'video/avi',
                            'video/mp4',
                            'video/quicktime',
                        ].includes(fileType)
                    ) {
                        setErrorMsg(
                            'Only HEVC, AVI, or MP4 videos are allowed.'
                        );
                        isValid = false;
                        return;
                    }
                }
                if (!file || !file.name) {
                    setErrorMsg('Please select a file.');
                    isValid = false;
                    return;
                } else if (
                    file &&
                    file['type'].split('/')[0] === 'image' &&
                    file.size > 5e6
                ) {
                    setErrorMsg('Please upload images smaller than 5 MB.');
                    isValid = false;
                    return;
                }
            });
        }

        if (isValid) {
            setTotalFileSize(totalSize);
            setFileList((prev) => [...prev, ...selectedFiles]);
        } else if (fileList.length < 1) {
            event.target.value = '';
        }
    };

    React.useEffect(() => {
        const totalSize = fileList.reduce((acc, file) => acc + file.size, 0);
        setTotalFileSize(totalSize);
    }, [fileList]);

    useEffect(() => {
        if (!isFirstRender.current) {
            scrollInnerContentToTop();
        } else {
            isFirstRender.current = false;
        }
    }, [formStatus]);

    const scrollInnerContentToTop = () => {
        innerContentRef.current.scrollIntoView({
            behavior: 'instant',
            block: 'start',
        });
    };

    const postImage = async () => {
        const formData = new FormData();
        fileList.forEach((file, index) => {
            formData.append(`files`, file);
        });
        const resp = await axios.post(
            `${GATSBY_API_URL}/customForm/support-contact/image`,
            formData,
            { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        return resp.data;
    };
    const getUserGeolocationDetails = async () => {
        // Skip API call in development mode to avoid 404 errors
        if (process.env.NODE_ENV === 'development') {
            return;
        }

        try {
            const resp = await axios.get(`${window.location.origin}/api`);
            setIpDetails(resp.data.ip);
        } catch (e) {
            console.error(e);
        }
    };
    React.useEffect(() => {
        getUserGeolocationDetails();
    }, []);

    const maxLengthCheck = (object: any) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(
                0,
                object.target.maxLength
            );
        } else {
            setPhoneValue(object.target.value);
        }
    };

    const sendDataToSalesForce = async (
        generatedImageUrl: [],
        swObj: { swcookie: string }
    ) => {
        try {
            let fieldTypes = { imageURL: generatedImageUrl };
            data.formValue.fields.map(
                (item: DataFields) =>
                    (fieldTypes[item.fieldName] =
                        item.fieldValue == undefined ? '' : item.fieldValue)
            );
            let dataObj = {
                formName: 'support contact custom form',
                payload: {
                    version: '0.01',
                    ...fieldTypes,
                    ...swObj,
                },
            };
            let response = await fetch(
                'https://hooks.zapier.com/hooks/catch/3762259/ovn75x1',
                {
                    method: 'POST',
                    headers: {},
                    body: JSON.stringify({ form: dataObj }),
                }
            );
            let json_data = await response.json();
            if (json_data.status == 'success') {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            setFormStatus('error');
            setIsLoading(false);
            // notify('Error occured while submitting the form');
            return false;
        }
    };

    const getHiddenFieldsValue = async (
        generatedImageUrl: [],
        swObj: { swcookie: string }
    ) => {
        try {
            let backUpData = JSON.parse(JSON.stringify(data));
            backUpData.formValue.fields.push(
                ...[
                    {
                        fieldName: 'imageUrl',
                        fieldValue: generatedImageUrl,
                    },
                    {
                        fieldName: 'swcookie',
                        fieldValue: swObj.swcookie,
                    },
                ]
            );
            backUpData.formValue.formName = 'support contact custom form';
            const response = await fetch(
                `${GATSBY_API_URL}/customForm/addFeedBack`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(backUpData),
                }
            );
            let body = await response.json();
            if (body.result == true) {
                return true;
            } else {
                return false;
            }
        } catch (err) {
            console.error(err);
            setFormStatus('error');
            setIsLoading(false);
            // notify('Error occured while submitting the form');
            return false;
        }
    };

    const formSubmit = async (e: any) => {
        setErrorMsg('');
        setIsLoading(true);
        e.preventDefault();
        try {
            if (honeyPotValue == '') {
                let modifiedFileUrls = [];
                if (fileList && fileList.length > 0) {
                    const filesKeys = await postImage();
                    if (
                        filesKeys.result == true &&
                        GATSBY_API_URL != undefined
                    ) {
                        modifiedFileUrls = filesKeys.value.map(
                            (key) => GATSBY_API_URL + '/' + key
                        );

                        setFinalFilesUrls(modifiedFileUrls);
                    } else if (filesKeys.result == false) {
                        setIsLoading(false);
                        // notify('Error occured while adding the attachment');
                        return false;
                    }
                }
                const swcookie: string = Cookies?.get('sw');
                const swObj = { swcookie: swcookie ? swcookie : '' };

                const salesforceSubmission = await sendDataToSalesForce(
                    modifiedFileUrls,
                    swObj
                );
                const dbSubmission = await getHiddenFieldsValue(
                    modifiedFileUrls,
                    swObj
                );
                if (!salesforceSubmission || !dbSubmission) {
                    setIsLoading(false);
                    setFormStatus('error');
                } else {
                    setFirstNameValue('');
                    setLastNameValue('');
                    setEmailValue('');
                    setPhoneValue('');
                    setMessageValue('');
                    setFileList([]);
                    setTotalFileSize(0);
                    setFinalFilesUrls([]);
                    setSubjectField('');
                    setKey(0);
                    setIsLoading(false);
                    setFormStatus('success');
                }
            }
        } catch (error) {
            setIsLoading(false);
            setFormStatus('error');
        }
    };

    const renderContactPhoneAndEmail = () => (
        <div className={styles.contact}>
            {contactEmail.length !== 0 && (
                <div className={styles.subHeadingContainer}>
                    <p className={styles.subheading}>Email Us:</p>
                    <p>
                        <a
                            href={`mailto:${contactEmail}?&subject=${subject}&body=${body}`}
                        >
                            {contactEmail}
                        </a>
                    </p>
                </div>
            )}
        </div>
    );

    const data: any = {
        formValue: {
            fields: [
                {
                    fieldName: 'pageTitle',
                    fieldValue: pageTitleValue,
                    isHidden: 'true',
                    fieldLabel: 'pageTitle',
                    isRequired: 'true',
                },
                {
                    fieldName: 'date',
                    fieldValue: today,
                    isHidden: 'true',
                    fieldLabel: 'date',
                    isRequired: 'true',
                },
                {
                    fieldName: 'iReferrer',
                    fieldValue: iReferrerValue,
                    isHidden: 'true',
                    fieldLabel: 'iReferrer',
                    isRequired: 'true',
                },
                {
                    fieldName: 'lReferrer',
                    fieldValue: lReferrerValue,
                    isHidden: 'true',
                    fieldLabel: 'lReferrer',
                    isRequired: 'true',
                },
                {
                    fieldName: 'iLandPage',
                    fieldValue: iLandPageValue,
                    isHidden: 'true',
                    fieldLabel: 'iLandPage',
                    isRequired: 'true',
                },
                {
                    fieldName: 'visits',
                    fieldValue: visitsValue,
                    isHidden: 'true',
                    fieldLabel: 'visits',
                    isRequired: 'true',
                },
                {
                    fieldName: 'usource',
                    fieldValue: utmSourceValue,
                    isHidden: 'true',
                    fieldLabel: 'usource',
                    isRequired: 'true',
                },
                {
                    fieldName: 'umedium',
                    fieldValue: utmMediumValue,
                    isHidden: 'true',
                    fieldLabel: 'umedium',
                    isRequired: 'true',
                },
                {
                    fieldName: 'ucampaign',
                    fieldValue: utmCampaignValue,
                    isHidden: 'true',
                    fieldLabel: 'ucampaign',
                    isRequired: 'true',
                },
                {
                    fieldName: 'ucontent',
                    fieldValue: ucontentValue,
                    isHidden: 'true',
                    fieldLabel: 'ucontent',
                    isRequired: 'true',
                },
                {
                    fieldName: 'marketingChannel',
                    fieldValue: marketingChannelValue,
                    isHidden: 'true',
                    fieldLabel: 'marketingChannel',
                    isRequired: 'true',
                },
                {
                    fieldName: 'leadSource',
                    fieldValue: leadsourceValue,
                    isHidden: 'true',
                    fieldLabel: 'leadSource',
                    isRequired: 'true',
                },
                {
                    fieldName: 'emailSubscriptionForm',
                    fieldValue: emailSubscriptionFormValue,
                    isHidden: 'true',
                    fieldLabel: 'emailSubscriptionForm',
                    isRequired: 'true',
                },
                {
                    fieldName: 'cid',
                    fieldValue: clientIDValue,
                    isHidden: 'true',
                    fieldLabel: 'cid',
                    isRequired: 'true',
                },
                {
                    fieldName: 'originOfLead',
                    fieldValue: originOfLeadValue,
                    isHidden: 'true',
                    fieldLabel: 'originOfLead',
                    isRequired: 'true',
                },
                {
                    fieldName: 'referrer',
                    fieldValue: iReferrerValue,
                    isHidden: 'true',
                    fieldLabel: 'referrer',
                    isRequired: 'true',
                },
                {
                    fieldName: 'firstName',
                    fieldValue: firstNameValue,
                    isHidden: 'false',
                    fieldLabel: firstNameLabel,
                    isRequired: 'true',
                },
                {
                    fieldName: 'lastName',
                    fieldValue: lastNameValue,
                    isHidden: 'false',
                    fieldLabel: lastNameLabel,
                    isRequired: 'true',
                },
                {
                    fieldName: 'email',
                    fieldValue: emailValue,
                    isHidden: 'false',
                    fieldLabel: emailAddressLabel,
                    isRequired: 'true',
                },
                {
                    fieldName: 'telephone',
                    fieldValue: phoneValue,
                    isHidden: 'false',
                    fieldLabel: phoneFieldLabel,
                    isRequired: 'true',
                },
                {
                    fieldName: 'message',
                    fieldValue: messageValue,
                    isHidden: 'false',
                    fieldLabel: messageFieldLabel,
                    isRequired: 'true',
                },
                {
                    fieldName: 'contact_method',
                    fieldValue: selectContactMethodDropdownValue,
                    isHidden: 'false',
                    fieldLabel: 'Contact Method',
                    isRequired: 'true',
                },
                {
                    fieldName: 'contact_time',
                    fieldValue: selectContactTimeDropdownValue,
                    isHidden: 'false',
                    fieldLabel: 'Contact Time',
                    isRequired: 'true',
                },
                {
                    fieldName: 'topics',
                    fieldValue: selectDropdownValue,
                    isHidden: 'false',
                    fieldLabel: 'Issue',
                    isRequired: 'true',
                },
                {
                    fieldName: 'myFile',
                    fieldValue: finalFilesUrls,
                    isHidden: 'false',
                    fieldLabel: uploadPhotoLabel,
                    isRequired: 'false',
                },
                {
                    fieldName: 'ipAddress',
                    fieldValue: ipDetails,
                    isHidden: 'true',
                    fieldLabel: ipDetails,
                    isRequired: 'false',
                },
                {
                    fieldName: 'subjectField',
                    fieldValue: subjectField,
                    isHidden: 'false',
                    fieldLabel: subjectFieldLabel,
                    isRequired: 'true',
                },
                {
                    fieldName: 'topics',
                    fieldValue: selectDropdownValue,
                    isHidden: 'false',
                    fieldLabel: 'Product Line*',
                    isRequired: 'false',
                },
            ],
        },
    };

    return (
        <div
            className={styles.wrapper}
            id={anchor_name?.value || undefined}
            ref={breakpoints.sm ? innerContentRef : undefined}
        >
            <Modal
                isOpen={isLoading}
                style={{
                    overlay: {
                        zIndex: 203,
                    },
                    content: {
                        position: 'absolute',
                        top: '2rem',
                        left: '2rem',
                        right: '2rem',
                        bottom: '2rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                    },
                }}
            >
                <img
                    src={loadingGif?.url}
                    alt={loadingGif?.name}
                    style={{
                        width: '150px',
                        height: '150px',
                    }}
                />
                <p>Loading...</p>
            </Modal>
            <div className={styles.innerContent}>
                <div className={styles.contactAndHoursPanel}>
                    <h2 className={styles.headline}>{headline?.value}</h2>
                    {showContactAndHours && (
                        <div>
                            <div className={styles.subheading}>
                                Support Hours:
                            </div>
                            {RichText(support_hours)}
                            {renderContactPhoneAndEmail()}
                            <div>
                                <p className={styles.subheading}>Call Us:</p>
                                <p
                                    ref={
                                        !breakpoints.sm
                                            ? innerContentRef
                                            : undefined
                                    }
                                >
                                    <a href={`tel:${callUsPhoneNumber}`}>
                                        {callUsPhoneNumber}
                                    </a>
                                </p>
                            </div>
                        </div>
                    )}
                </div>
                {jotForm ? (
                    <div className={styles.jotFormPanel}>
                        <Jotform
                            formStyle={'embed'}
                            formUrl={jotForm}
                            display={true}
                        ></Jotform>
                    </div>
                ) : (
                    <div className={styles.formPanel}>
                        {showForm && formStatus == 'initial' && (
                            <form
                                name="customForm"
                                onSubmit={formSubmit}
                                className={`${isIOS ? styles.iosspecfs : ''}`}
                            >
                                <div className={styles.form}>
                                    <input
                                        type="hidden"
                                        id="pageTitle"
                                        name="pageTitle"
                                        value={pageTitleValue}
                                    />
                                    <input
                                        type="hidden"
                                        id="date"
                                        name="date"
                                        value={today}
                                    />
                                    <input
                                        type="hidden"
                                        id="iReferrer"
                                        name="iReferrer"
                                        value={iReferrerValue}
                                    />
                                    <input //get values from cookies
                                        type="hidden"
                                        id="lReferrer"
                                        name="lReferrer"
                                        value={lReferrerValue}
                                    />
                                    <input //first page that was visited to the website
                                        type="hidden"
                                        id="iLandPage"
                                        name="iLandPage"
                                        value={iLandPageValue}
                                    />
                                    <input
                                        type="hidden"
                                        id="visits"
                                        name="visits"
                                        value={visitsValue}
                                    />
                                    <input //google tag manager
                                        type="hidden"
                                        id="usource"
                                        name="usource"
                                        value={utmSourceValue}
                                    />
                                    <input
                                        type="hidden"
                                        id="umedium" // google facebook
                                        name="umedium"
                                        value={utmMediumValue}
                                    />
                                    <input
                                        type="hidden"
                                        id="ucampaign"
                                        name="ucampaign"
                                        value={utmCampaignValue}
                                    />
                                    <input
                                        type="hidden"
                                        id="ucontent"
                                        name="ucontent"
                                        value={ucontentValue}
                                    />
                                    <input
                                        type="hidden"
                                        id="marketingChannel"
                                        name="marketingChannel"
                                        value={marketingChannelValue}
                                    />
                                    <input
                                        type="hidden"
                                        id="leadSource"
                                        name="leadSource"
                                        value={leadsourceValue}
                                    />
                                    <input
                                        type="hidden"
                                        id="emailSubscriptionForm"
                                        name="emailSubscriptionForm"
                                        value={emailSubscriptionFormValue}
                                    />
                                    <input //client id obtained from google analytics..
                                        type="hidden"
                                        id="cid"
                                        name="cid"
                                        value={clientIDValue}
                                    />
                                    <input
                                        type="hidden"
                                        id="originOfLead"
                                        name="originOfLead"
                                        value={originOfLeadValue}
                                    />
                                    <input
                                        type="hidden"
                                        id="referrer"
                                        name="referrer"
                                        value={iReferrerValue}
                                    />
                                    <div className={styles.col}>
                                        <label htmlFor="firstName">
                                            {firstNameLabel}
                                        </label>
                                        <input
                                            id="website"
                                            name="website"
                                            type="text"
                                            className={
                                                styles.honeyPotInputField
                                            }
                                            value={honeyPotValue}
                                            onChange={(e) =>
                                                setHoneyPotValue(e.target.value)
                                            }
                                        />
                                        <input
                                            required
                                            type="text"
                                            name="firstName"
                                            id="firstName"
                                            value={firstNameValue}
                                            onChange={(e) =>
                                                setFirstNameValue(
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </div>
                                    <div className={styles.col}>
                                        <label htmlFor="lastName">
                                            {lastNameLabel}
                                        </label>
                                        <input
                                            required
                                            type="text"
                                            name="lastName"
                                            id="lastName"
                                            value={lastNameValue}
                                            onChange={(e) =>
                                                setLastNameValue(e.target.value)
                                            }
                                        />
                                    </div>
                                    <div className={styles.col}>
                                        <label htmlFor="email">
                                            {emailAddressLabel}
                                        </label>
                                        <input
                                            required
                                            type="email"
                                            name="email"
                                            id="email"
                                            value={emailValue}
                                            onChange={(e) =>
                                                setEmailValue(e.target.value)
                                            }
                                        />
                                    </div>
                                    <div className={styles.col}>
                                        <label htmlFor="telephone">
                                            {phoneFieldLabel}
                                        </label>
                                        <input
                                            required
                                            type="number"
                                            name="telephone"
                                            id="telephone"
                                            value={phoneValue}
                                            maxLength={14}
                                            onInput={(e) => maxLengthCheck(e)}
                                        />

                                        {/* <input
                                            required
                                            maxLength={10}
                                            pattern={"\d{10}"}
                                            type="number"
                                            name="telephone"
                                            id="telephone"
                                            value={phoneValue}
                                            onChange={(e) =>
                                                setPhoneValue(e.target.value)
                                            }
                                        /> */}
                                    </div>
                                    <div className={styles.col}>
                                        <label htmlFor="contact_method">
                                            Contact Method*
                                        </label>
                                        <select
                                            name="contact_method"
                                            id="contact_method"
                                            required
                                            value={
                                                selectContactMethodDropdownValue
                                            }
                                            onChange={(e) =>
                                                setSelectContactMethodDropdownValue(
                                                    e.target.value
                                                )
                                            }
                                        >
                                            <option value="" disabled>
                                                Make a selection
                                            </option>
                                            {contactMethodList?.node?.terms?.map(
                                                (contactMethod, index) => (
                                                    <option
                                                        key={'option' + index}
                                                        value={
                                                            contactMethod.codename
                                                        }
                                                    >
                                                        {contactMethod.name}
                                                    </option>
                                                )
                                            )}
                                        </select>
                                    </div>
                                    <div className={styles.col}>
                                        <label htmlFor="contact_time">
                                            Contact Time*
                                        </label>
                                        <select
                                            name="contact_time"
                                            id="contact_time"
                                            required
                                            value={
                                                selectContactTimeDropdownValue
                                            }
                                            onChange={(e) =>
                                                setSelectContactTimeDropdownValue(
                                                    e.target.value
                                                )
                                            }
                                        >
                                            <option value="" disabled>
                                                Make a selection
                                            </option>
                                            {contactTimeList?.node?.terms?.map(
                                                (contactTime, index) => (
                                                    <option
                                                        key={'option' + index}
                                                        value={
                                                            contactTime.codename
                                                        }
                                                    >
                                                        {contactTime.name}
                                                    </option>
                                                )
                                            )}
                                        </select>
                                    </div>
                                    <div className={styles.prodLine}>
                                        <label htmlFor="topics">
                                            Product Line*
                                        </label>
                                        <select
                                            name="topics"
                                            id="topics"
                                            required
                                            value={selectDropdownValue}
                                            onChange={(e) =>
                                                setSelectDropdownValue(
                                                    e.target.value
                                                )
                                            }
                                        >
                                            <option value="" disabled>
                                                Make a selection
                                            </option>
                                            {productLineList.node?.terms?.map(
                                                (productLine, index) => (
                                                    <option
                                                        key={'option' + index}
                                                        value={
                                                            productLine.codename
                                                        }
                                                    >
                                                        {productLine.name}
                                                    </option>
                                                )
                                            )}
                                        </select>
                                    </div>
                                    <div className={styles.messageField}>
                                        <label htmlFor="subjectField">
                                            {subjectFieldLabel}
                                        </label>
                                        <input
                                            required
                                            name="subjectField"
                                            id="subjectField"
                                            value={subjectField}
                                            onChange={(e) =>
                                                setSubjectField(e.target.value)
                                            }
                                        />
                                    </div>
                                    <div className={styles.messageField}>
                                        <label htmlFor="message">
                                            {messageFieldLabel}
                                        </label>
                                        <textarea
                                            required
                                            name="message"
                                            id="message"
                                            value={messageValue}
                                            onChange={(e) =>
                                                setMessageValue(e.target.value)
                                            }
                                        ></textarea>
                                        <div className={styles.buttons}></div>
                                        <div className={styles.disclaimer}>
                                            {RichText(
                                                attachment_disclaimer_text
                                            )}
                                        </div>
                                    </div>
                                    <div className={styles.buttons}>
                                        <label
                                            htmlFor="file-upload"
                                            className={styles.customFileUpload}
                                        >
                                            {' '}
                                            {uploadPhotoLabel}
                                        </label>
                                        <input
                                            type="file"
                                            accept="image/*, video/hevc, video/avi, video/, video/quicktime"
                                            name="myFile"
                                            id="file-upload"
                                            onChange={onFileChange}
                                            multiple
                                            key={key}
                                        />
                                        <button type="submit">
                                            {submission_cta_label?.value}
                                        </button>
                                    </div>
                                </div>
                                <div className={styles.filesContainer}>
                                    <ul>
                                        {fileList.map((ff, idx, index) => {
                                            return (
                                                <li key={idx}>
                                                    <div
                                                        className={
                                                            styles.fileName
                                                        }
                                                    >
                                                        {ff.name}
                                                    </div>
                                                    <div
                                                        className={
                                                            styles.closeButton
                                                        }
                                                    >
                                                        <CloseButton
                                                            onClick={() =>
                                                                removeFile(idx)
                                                            }
                                                            visualStyle="dark"
                                                        />
                                                    </div>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                    {errorMsg != '' && (
                                        <div className={styles.errorMsg}>
                                            {errorMsg}
                                        </div>
                                    )}
                                </div>
                            </form>
                        )}
                        {formStatus === 'success' && (
                            <div className={styles.confirmationContainer}>
                                <h3 className={styles.formSubmitHeadline}>
                                    {formSubmitConfirmationheadline}
                                </h3>
                                <div className={styles.formSbmitDescription}>
                                    {RichText(
                                        form_submission_confirmation_description
                                    )}
                                </div>
                                {confirmation_button_copy.value !== '' && (
                                    <div>
                                        <button
                                            type="button"
                                            className={styles.ctaa}
                                            onClick={() =>
                                                setFormStatus('initial')
                                            }
                                        >
                                            {confirmation_button_copy.value}
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}

                        {formStatus === 'error' && (
                            <div className={styles.confirmationContainer}>
                                <h3 className={styles.formSubmitHeadline}>
                                    {formErrorMessageHeadline}
                                </h3>
                                <div className={styles.formSbmitDescription}>
                                    {RichText(form_error_message_description)}
                                </div>
                                {form_error_message_button_copy.value !==
                                    '' && (
                                    <div>
                                        <button
                                            type="button"
                                            className={styles.ctaa}
                                            onClick={() =>
                                                setFormStatus('initial')
                                            }
                                        >
                                            {
                                                form_error_message_button_copy.value
                                            }
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}

                        {showContactAndHours && !breakpoints.l
                            ? renderContactPhoneAndEmail()
                            : null}
                    </div>
                )}
            </div>
            <ToastContainer />
        </div>
    );
};

export default SupportContactPanel;

export const fragmentSupportContactPanel = graphql`
    fragment SupportContactPanel on kontent_item_component___support_contact_panel {
        elements {
            anchor_name {
                value
            }
            associated_typeform {
                value
            }
            contact_email {
                value
            }
            contact_email_default_body {
                value
            }
            contact_email_subject {
                value
            }
            email_field {
                value
            }
            headline {
                value
            }
            message_field {
                value
            }
            first_name_field {
                value
            }
            last_name_field {
                value
            }
            phone_field {
                value
            }
            photo_button_cta_label {
                value
            }

            show_or_hide_contact_and_hours {
                value {
                    codename
                }
            }
            show_or_hide_form {
                value {
                    codename
                }
            }
            submission_cta_label {
                value
            }
            support_hours {
                value
                links {
                    codename
                }
                images {
                    url
                }
            }
            attachment_disclaimer_text {
                value
            }
            form_submission_confirmation_headline {
                value
            }
            form_submission_confirmation_description {
                ...kontentRichText
            }
            confirmation_button_copy {
                value
            }
            form_error_message_headline {
                value
            }
            form_error_message_description {
                ...kontentRichText
            }
            form_error_message_button_copy {
                value
            }
            call_us_phone_number {
                value
            }
            issues_list {
                value {
                    ... on kontent_item_taxonomy_category {
                        id
                        elements {
                            associated_taxonomy_code_name {
                                value
                            }
                        }
                    }
                }
            }
            order_number_field {
                value
            }
            subject_field {
                value
            }
            product_line_list {
                value {
                    ... on kontent_item_taxonomy_category {
                        id
                        elements {
                            associated_taxonomy_code_name {
                                value
                            }
                        }
                    }
                }
            }
            contact_method {
                value {
                    ... on kontent_item_taxonomy_category {
                        id
                        elements {
                            associated_taxonomy_code_name {
                                value
                            }
                        }
                    }
                }
            }
            contact_time {
                value {
                    ... on kontent_item_taxonomy_category {
                        id
                        elements {
                            associated_taxonomy_code_name {
                                value
                            }
                        }
                    }
                }
            }
            loading_image {
                value {
                    ... on kontent_item_media___image {
                        id
                        elements {
                            file {
                                value {
                                    url
                                    name
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
